export default () => ({
  PROVIDER_TYPES: {
    JWPLAYER: 'JWPLAYER',
    BRIGHTCOVE: 'BRIGHTCOVE'
  }
});
